import { Button } from "@/src/components/buttons";
import { closeDrawer, openDrawer } from "@/src/components/dialogs";
import { UploadCards } from "@/src/components/uploadSpots";
import {
  Complication,
  Evolution,
  EvolutionItem,
  Intervention,
  Patient,
} from "@/src/data/allTypes";
import { sleep } from "@/src/utils/apiFetch";
import { formatDate } from "@/src/utils/utils";
import { HtmlVisualiser } from "../documents/documentEditor";
import { FieldAnswersList } from "../fields/fieldsAnswersList";

export async function openEvolutionVisualisationDrawer<
  T extends EvolutionItem
>({ patient, items, index }: { patient: Patient; items: T[]; index: number }) {
  let item = items[index];
  if (!item) return;
  let nextItem = items[index + 1];
  let previousItem = items[index - 1];
  const reference = (item as Complication).reference;
  await openDrawer({
    id: "itemVisualisation",
    additionalClasses: ["medium"],

    title: (
      <div className="c1-auto gap10">
        <div>
          <div className="bold">{item.type}</div>
          <div className="gray f14">{formatDate(item._date, "LL HH:mm")}</div>
        </div>
      </div>
    ),
    content: (
      <div className="grid c1 gap10">
        {reference && (
          <div>
            <div className="capitalize bold">{reference.name}</div>
          </div>
        )}
        <HtmlVisualiser content={item.notes}></HtmlVisualiser>
        <FieldAnswersList
          patient={patient}
          reference={
            (item as Evolution).refAnswer?.reference ||
            (item as Intervention).content?.reference
          }
          answers={
            (item as Evolution).refAnswer?.fieldAnswers ||
            (item as Intervention).content?.fieldAnswers ||
            []
          }
        ></FieldAnswersList>
        <div>
          <div className="bold">{item.conclusion}</div>
        </div>
        <div>
          <UploadCards uploads={item.uploads} count={2} />
        </div>
      </div>
    ),
    footer: (
      <div className="c3 gap10 p15">
        <Button
          type={"tertiary"}
          isDisabled={!previousItem}
          onClick={async () => {
            closeDrawer("itemVisualisation");
            await sleep(100);
            openEvolutionVisualisationDrawer({
              items,
              index: index - 1,
              patient,
            });
          }}
        >
          Précédent
        </Button>
        <div></div>
        <Button
          type={"tertiary"}
          isDisabled={!nextItem}
          onClick={async () => {
            closeDrawer("itemVisualisation");
            await sleep(100);
            openEvolutionVisualisationDrawer({
              items,
              index: index + 1,
              patient,
            });
          }}
        >
          Suivant
        </Button>
      </div>
    ),
  });
}
